import { paymentsApi } from '.';

export interface MarketingPreferencesUpdateRequest {
  transactionId: string | null,
  subscriptionId: string | null,
  permissionEmail: 1 | null,
  permissionPost: 1 | null,
  permissionPhone: 1 | null,
  permissionSMS: 1 | null,
  phone: string | null,
  mobile: string | null,
}

export interface MarketingPreferencesUpdateResponse {
  data: object,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    updateMarketingPreferences: builder.mutation<MarketingPreferencesUpdateResponse, MarketingPreferencesUpdateRequest>({
      query: body => ({
        url: 'transaction/update-marketing-preferences',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useUpdateMarketingPreferencesMutation } = extendedPaymentsApi;
